import React from 'react';

import { AdminAccessLogo } from './AdminAccessLogo';
import { AdminCompanySummary } from './planTypes';
import { companySubtitle } from './planDisplayHelpers';
import { SidebarSelector } from './SidebarSelector';
import { TEXTOS_DE_NAVEGACION, TextosDeNavegacion } from './navTextos';

/**
 * Pieza del Sidebar: el selector de empresa en Admin. Ocupa el mismo sitio que el de planes, que en Admin
 * se esconde, y reutiliza `SidebarSelector`: mismo botón, mismo desplegable y mismas reglas. Cada empresa
 * lleva «Admin» al lado del nombre. Con VARIAS SL es un desplegable, y SIEMPRE hay una empresa elegida: si
 * quien lo monta no dice cuál, la primera (en Admin se está mirando una empresa, nunca «ninguna»). Con
 * UNA sola se enseña el campo igualmente, pero sin desplegable, porque no hay nada que elegir. Sin
 * «Resumen de planes» (eso es de la vista personal).
 */
export interface SidebarCompanySelectorProps {
	companies: AdminCompanySummary[];
	activeCompanyId?: string;
	onSelectCompany: (company: AdminCompanySummary) => void;
	isMenuOpen: boolean;
	textos?: Pick<TextosDeNavegacion, 'seleccionarEmpresa' | 'selectorDeEmpresa' | 'admin'>;
}

export const SidebarCompanySelector = ({
	companies,
	activeCompanyId,
	onSelectCompany,
	isMenuOpen,
	textos = TEXTOS_DE_NAVEGACION
}: SidebarCompanySelectorProps) => {
	const unica = companies.length === 1;
	// Siempre una elegida: la indicada, si existe, y si no, la primera.
	const elegida = companies.some((c) => c.id === activeCompanyId)
		? activeCompanyId
		: companies[0]?.id;

	return (
		<SidebarSelector
			options={companies.map((company) => ({
				id: company.id,
				label: company.name,
				subtitle: companySubtitle(company),
				badge: textos.admin,
				logo: (className) => <AdminAccessLogo className={className} />
			}))}
			activeId={elegida}
			onSelect={(id) => {
				const company = companies.find((c) => c.id === id);
				if (company) onSelectCompany(company);
			}}
			placeholder={textos.seleccionarEmpresa}
			ariaLabel={textos.selectorDeEmpresa}
			isMenuOpen={isMenuOpen}
			selectable={!unica}
		/>
	);
};
